export default {
	data() {
		return {
			debouncedEmissions: {},
		};
	},

	methods: {
		/**
		 * @param events - one or more event names to bubble
		 * @returns {Object.<String, Function>}
		 * @code
		 *
		 * <template>
		 *     <!-- bubbles events to parent component -->
		 *     <Enterprise v-on="bubble( `warpSpeed`, `firePhasers` ) />
		 * </template>
		 *
		 * <script>
		 * export default {
		 *     mixins: [ EventsMixin, ],
		 *     emits: [ "warpSpeed", "firePhasers", ],
		 * }
		 * </script>
		 */
		bubble( ...events ) {
			return events.reduce( ( on, eventName ) => {
				on[ eventName ] = ( ...args ) => this.$emit( eventName, ...args );
				return on;
			}, {} );
		},

		emitDebounce( eventName, timeout, ...args ) {
			const clearEvent = () => {
				clearTimeout( this.debouncedEmissions[ eventName ] );
				this.debouncedEmissions[ eventName ] = null;
			};
			if ( this.debouncedEmissions[ eventName ] ) {
				clearEvent();
			}
			this.debouncedEmissions[ eventName ] = setTimeout( () => {
				this.$emit( eventName, ...args );
				clearEvent();
			}, timeout );
		},
	},

	beforeUnmount() {
		Object.keys( this.debouncedEmissions ).forEach( eventName => {
			clearTimeout( this.debouncedEmissions[ eventName ] );
			this.debouncedEmissions[ eventName ] = null;
		} );
	},
};
